/* unplugin-vue-components disabled */import { render } from "./NetNoticeList.vue?vue&type=template&id=0efcc76d&scoped=true"
import script from "./NetNoticeList.vue?vue&type=script&lang=js"
export * from "./NetNoticeList.vue?vue&type=script&lang=js"

import "./NetNoticeList.vue?vue&type=style&index=0&id=0efcc76d&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efcc76d"]])

export default __exports__